<template>
  <div class="flex items-center justify-center gap-1 px-3 py-1.5">
    <div class="flex items-center">
      <p class="text-body-default-m loading-fade">
        {{ loadingText }}
      </p>
    </div>
    <Icon class="text-fgr-hint animate-[spin_2s_linear_infinite]" src="circleNotch" :size="ComponentSize.lg" />
  </div>
</template>

<script lang="ts" setup>
  const props = withDefaults(
    defineProps<{
      loadingText?: string;
    }>(),
    {
      loadingText: "Loading...",
    }
  );
</script>
